// extracted by mini-css-extract-plugin
export default {"section-label":"Hello-module__section-label__ilFTT","section-label-text":"Hello-module__section-label-text__rhusm"};